module.exports = __webpack_public_path__ + "static/banner-placements-mobile-3faffcde05c2ddca0c7e01fd618c5468.jpg";